import React from 'react';
import { FaClipboardCheck, FaHistory, FaSearch, FaThLarge, FaUserShield } from 'react-icons/fa';
import './DashboardSidebar.css';

function DashboardSidebar({
  currentPage,
  onNavigateHome,
  onNavigateNomineeCheck,
  onNavigateNomineeLookup,
  onNavigateVerificationHistory,
  onNavigateAdmin,
  isAdmin,
}) {
  return (
    <aside className="dashboard-sidebar" aria-label="Dashboard navigation">
      <p className="dashboard-sidebar-label">Menu</p>
      <nav className="dashboard-sidebar-nav">
        <button
          type="button"
          className={`dashboard-sidebar-link ${currentPage === 'home' ? 'active' : ''}`}
          onClick={onNavigateHome}
          aria-current={currentPage === 'home' ? 'page' : undefined}
        >
          <span className="dashboard-sidebar-icon" aria-hidden="true">
            <FaThLarge />
          </span>
          <span className="dashboard-sidebar-text">
            <strong>Dashboard</strong>
            <small>Assets &amp; nominees</small>
          </span>
        </button>

        <button
          type="button"
          className={`dashboard-sidebar-link ${currentPage === 'nominee-check' ? 'active' : ''}`}
          onClick={onNavigateNomineeCheck}
          aria-current={currentPage === 'nominee-check' ? 'page' : undefined}
        >
          <span className="dashboard-sidebar-icon" aria-hidden="true">
            <FaClipboardCheck />
          </span>
          <span className="dashboard-sidebar-text">
            <strong>Notify All Nominees</strong>
            <small>By account holder email</small>
          </span>
        </button>

        <button
          type="button"
          className={`dashboard-sidebar-link ${currentPage === 'nominee-lookup' ? 'active' : ''}`}
          onClick={onNavigateNomineeLookup}
          aria-current={currentPage === 'nominee-lookup' ? 'page' : undefined}
        >
          <span className="dashboard-sidebar-icon" aria-hidden="true">
            <FaSearch />
          </span>
          <span className="dashboard-sidebar-text">
            <strong>Nominee Lookup</strong>
            <small>Find records by nominee contact</small>
          </span>
        </button>

        <button
          type="button"
          className={`dashboard-sidebar-link ${currentPage === 'verification-history' ? 'active' : ''}`}
          onClick={onNavigateVerificationHistory}
          aria-current={currentPage === 'verification-history' ? 'page' : undefined}
        >
          <span className="dashboard-sidebar-icon" aria-hidden="true">
            <FaHistory />
          </span>
          <span className="dashboard-sidebar-text">
            <strong>Verification History</strong>
            <small>Paid &amp; unpaid checks</small>
          </span>
        </button>

        {isAdmin ? (
          <button
            type="button"
            className={`dashboard-sidebar-link ${currentPage === 'admin' ? 'active' : ''}`}
            onClick={onNavigateAdmin}
            aria-current={currentPage === 'admin' ? 'page' : undefined}
          >
            <span className="dashboard-sidebar-icon" aria-hidden="true">
              <FaUserShield />
            </span>
            <span className="dashboard-sidebar-text">
              <strong>Admin</strong>
              <small>System tracking &amp; payments</small>
            </span>
          </button>
        ) : null}
      </nav>
    </aside>
  );
}

export default DashboardSidebar;
